export const stringifyArgs = (...args) => args.reduce((acc, arg) => acc + JSON.stringify(arg));